import React from 'react';
import usePayments from '../../../../../hooks/api/usePayments';
import AddSubscription from './AddSubscription';
import SubscriptionDetails from './SubscriptionDetails';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { useInitializePayments } from '../../../../../hooks/useInitializePayments';

export type SubscriptionScreenOwnProps = {};

export type SubscriptionScreenProps = SubscriptionScreenOwnProps;

const SubscriptionScreen: React.FC<SubscriptionScreenProps> = () => {
    // initialize app payment
    useInitializePayments();
    const { paymentStatus, isLoadingPaymentStatus } = usePayments({});

    const isPaid = paymentStatus?.entitlements.includes('Family Plan');

    return (
        <AnimateLoadedContent isLoading={isLoadingPaymentStatus}>
            {() => (isPaid ? <SubscriptionDetails /> : <AddSubscription />)}
        </AnimateLoadedContent>
    );
};

export default React.memo(SubscriptionScreen);
